<template>
    <div>
        <slot v-if="!loading"></slot>
    </div>

</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import $ from 'jquery'

export default {
  data () {
    return {
        loading: true,
        resizeIframeProc: null
    }
  },
  methods: {
    checkUser() {
        if (!localStorage.getItem("lfp-auth-user")) {
            this.createGuestUser();
        }
        else {
            this.loading = false;
        }
    },

    createGuestUser() {
        let self = this;
        let url = `${process.env.VUE_APP_API_ENDPOINT}/me/create-guest-user`;

        axios.get(url).then(function(response) {
            localStorage.setItem("lfp-auth-user", response.data.token)
            // self.loading = false;

            window.location = window.location.href;
        });
    },

    createIframeResizeProc() {
        this.resizeIframeProc = setInterval(function() {
            let new_height = $('.v-main__wrap > div').height() + 30;
            parent.postMessage({
                event_id: 'resizeWidgetIframe',
                data: {
                    new_height: new_height
                }
            },"*");  //  `*` on any domain
        }, 250);
    },

    styleBody() {
        var styleSheet = document.createElement("style")
        styleSheet.type = "text/css"
        styleSheet.innerText = 'body::-webkit-scrollbar { display: none;  }';
        styleSheet.id = 'lfp-public-widgets-css-hide-body';
        document.body.appendChild(styleSheet);
    }
  },
  created() {
    this.checkUser();
    this.createIframeResizeProc();
    this.styleBody();
  },
  destroyed() {
    clearInterval(this.resizeIframeProc);
    this.resizeIframeProc = null;
  }
}
</script>